var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoTradeIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9378 26.5425V48.4585H41.6458V26.5425H47.9378ZM34.7425 34.8755V48.4585H28.4515V34.8755H34.7425ZM21.5482 22.3755V48.4585H15.2571V22.3755H21.5482ZM8.35382 30.7085V48.4585H2.06281V30.7085H8.35382ZM32.2913 15.7749L40.5325 7.53369L36.1234 3.12451L36.6653 2.5835H48.4583V14.3765L47.9163 14.9175L43.5081 10.5093L33.7796 20.2378L32.2913 21.7251L18.7503 8.18408L4.96613 21.9683L1.99054 18.9927L17.262 3.72119L18.7493 2.23291L32.2913 15.7749Z",
    stroke: "url(#paint0_linear_15_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_7",
    x1: 25.1209,
    y1: 1.52588,
    x2: 25.1209,
    y2: 48.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTradeIconWhite);
export default __webpack_public_path__ + "static/media/autoTradeIconWhite.0a0e68cb5e0d5329f8826ffe31c92895.svg";
export { ForwardRef as ReactComponent };